/**
 * Google Tag Manager (GTM) integration for Vue 3
 *
 * @link https://www.npmjs.com/package/@gtm-support/vue-gtm
 */

import { createGtm } from '@gtm-support/vue-gtm'
import router from "@/router"

const enabled = !!import.meta.env.VITE_GTM_ID
const debug   = !!import.meta.env.VITE_LOCAL_SERVER

export default createGtm({
    id: import.meta.env.VITE_GTM_ID,
    // source: `https://${import.meta.env.VITE_HMR_DOMAIN}/gtm.js`, // Add your own serverside GTM script
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    // nonce: '2726c7f26c', // Will add `nonce` to the script tag

    // optional parameters
    enabled: enabled, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: debug, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    ignoredViews: [], // Don't trigger events for specified router names (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
})
